export const Contrat = {
    path: '/contrats',
    name: 'contrats',
    component: () => import('@/views/Contrat/ContratPage.vue'),
    children: [
        {
            path: '/contrats/add',
            name: 'contrats.add',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/contrats/edit/:id',
            name: 'contrats.edit',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/contrats/view/:id',
            name: 'contrats.view',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/contrats/renew/:id',
            name: 'contrats.renew',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {renewAction: true}
        },
        {
            path: '/contrats/archive/:id',
            name: 'contrats.archive',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {archiveAction: true}
        },
        {
            path: '/contrats/unarchive/:id',
            name: 'contrats.unarchive',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {unarchiveAction: true}
        },
        {
            path: '/contrats/handle_trial_period/:id',
            name: 'contrats.handle_trial_period',
            component: () => import('@/views/Contrat/Form/HandleTrialPeriodForm.vue'),
        },
        {
            path: '/contrats/activate/:id',
            name: 'contrats.activate',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {activateAction: true}
        },
        {
            path: '/contrats/delete/:id',
            name: 'contrats.delete',
            component: () => import('@/views/Contrat/Form/ContratForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/contrats/print/:id',
            name: 'contrats.print',
            component: () => import('@/views/Contrat/Form/PrintForm.vue'),
        },
        {
            path: '/contrats/leaving/:id',
            name: 'contrats.leaving',
            component: () => import('@/views/Contrat/Form/LeavingForm.vue'),
            props: {update_action: true},
        },
        {
            path: '/contrats/documents/:id',
            name: 'contrats.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "CONTRAT"}
        },
        {
            path: '/contrats/template_applications/:id',
            name: 'contrats.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "CONTRAT"}
        },
    ],
}
